"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JourneyActionForwardMail = void 0;
const base_1 = require("./base");
const enums_1 = require("../../enums");
const constants_1 = require("../constants");
const utils_1 = require("../utils");
exports.JourneyActionForwardMail = (0, base_1.journeyAction)({
    action: enums_1.JourneyActionEnum.ForwardMail,
    settings_schema: (0, base_1.settingsValidationSchema)({
        mail_account_id: {
            type: 'number',
            required: true,
        },
        to: {
            type: 'string',
            email: { tlds: { allow: false, }, },
            required: true,
        },
        cc: {
            type: 'array',
            items: {
                type: 'string',
                email: { tlds: { allow: false, }, },
            },
        },
        bcc: {
            type: 'array',
            items: {
                type: 'string',
                email: { tlds: { allow: false, }, },
            },
        },
        subject: {
            type: 'string',
            allow: [null,],
        },
        body: {
            type: 'string',
        },
    }),
    getPorts: (node) => {
        return Object.assign(Object.assign({}, base_1.journeyDefaultInputPort), { [constants_1.JOURNEY_ACTION_FORWARD_MAIL_OUTPUT]: (0, utils_1.journeyNodePortAddDefault)({
                id: constants_1.JOURNEY_ACTION_FORWARD_MAIL_OUTPUT,
                type: enums_1.JourneyPortDirectionEnum.Output,
                removable: false,
                required: false,
                index: 0,
                title: 'NEXT',
                color: null,
            }) });
    },
});
